module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "phone-confirm.607b9c70.png";